import { getEntity, getEntityMap } from 'data'

export const getComments = state => getEntityMap(state, 'Comment')

export const getComment = (state, commentId) =>
  getEntity(state, 'Comment', commentId)
